/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import BaseSettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { hasFeature } from 'embercom/helpers/has-feature';

export default class Macros extends BaseSettingsRoute {
  @service intercomEventService;
  @service intl;
  @service store;
  @service appService;
  @service workflowConnectorInsertableActions;
  @service ticketStateService;

  get titleToken() {
    return this.intl.t('new-settings.submenu.helpdesk.macros');
  }

  @action
  willTransition(transition) {
    if (
      this.controller.hasUnsavedChanges &&
      !confirm(this.intl.t('inbox.manage-macros.saved-replies.warning-text'))
    ) {
      transition.abort();
    } else {
      this.controller.cancelEditingReply();
    }
  }

  async model() {
    let app = this.modelFor('apps.app');

    let savedReplies = await this.store.query('saved-reply', { page: 1, per_page: 50 });

    let conversationCustomAttributes = await this.store.findAll(
      'conversation-attributes/descriptor',
    );

    await this.workflowConnectorInsertableActions.loadActions();

    if (hasFeature('spg-inbox-ticket-state-macro-action', this.appService)) {
      await this.ticketStateService.setup();
    }

    return {
      app,
      savedReplyTypes: app.savedReplyTypes,
      savedReplies,
      meta: savedReplies.meta,
      conversationCustomAttributes,
    };
  }
}
